import React from "react";
import { TABLE_PAGE_SIZE } from "../../constants/constants";
import "./styles.scss";

const TablePaginationCount = ({ pagination }) => {
  let { current: currentPage, total: totalResults, tablePageSize } = pagination;
  if (!totalResults) return <></>;
  if (!currentPage) currentPage = 1;

  const pageSize = tablePageSize || TABLE_PAGE_SIZE;

  return (
    <>
      <div data-testid="pagination" className="results-count">{`Showing ${
        currentPage > 1 ? currentPage * pageSize - (pageSize - 1) : 1
      } to ${
        currentPage * pageSize < totalResults
          ? currentPage * pageSize
          : currentPage * pageSize - (currentPage * pageSize - totalResults)
      } of ${totalResults} results`}</div>
    </>
  );
};

export default TablePaginationCount;
